import { render, staticRenderFns } from "./CancelIcon.vue?vue&type=template&id=6c88fa67&"
import script from "./CancelIcon.vue?vue&type=script&lang=ts&"
export * from "./CancelIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports